import { render, staticRenderFns } from "./page-attr-edit.vue?vue&type=template&id=186e2e96&scoped=true"
import script from "./page-attr-edit.vue?vue&type=script&lang=js"
export * from "./page-attr-edit.vue?vue&type=script&lang=js"
import style0 from "./page-attr-edit.vue?vue&type=style&index=0&id=186e2e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186e2e96",
  null
  
)

export default component.exports